import { useNavigate } from 'react-router';

const BackToLoginButton = () => {
    const navigate = useNavigate();
    return <button className="back-button" onClick={() => navigate('/login')} />;
};

export default BackToLoginButton;
